var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-not-found',{on:{"toPreviousPage":_vm.toPreviousPageRoute,"toHomepage":_vm.toHomepageRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }